export default __webpack_public_path__ + "static/media/fm-logo-white.94588e27.svg";